import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=f01010b4&scoped=true"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01010b4",
  null
  
)

export default component.exports